export const EGsaType = {
  "0": "UNKNOWN",
  "1": "RETAIL",
  "2": "WHOLESALE",
  "3": "INTRANET",
  "4": "EXTRANET",
  "-1": "ALL"
};